var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.8073 5.58842C7.65803 5.58842 7.53703 5.70942 7.53703 5.85869V24.7772H23.2447V11.799C23.2447 11.6584 23.1899 11.5233 23.0919 11.4224L17.5848 5.75235C17.4831 5.64755 17.3432 5.58842 17.1971 5.58842H7.8073ZM5.91541 5.85869C5.91541 4.81382 6.76244 3.9668 7.8073 3.9668H17.1971C17.7815 3.9668 18.341 4.20334 18.7481 4.62254L24.2552 10.2926C24.6471 10.6961 24.8663 11.2365 24.8663 11.799V25.5881C24.8663 26.0359 24.5033 26.3989 24.0555 26.3989H6.72622C6.27842 26.3989 5.91541 26.0359 5.91541 25.5881V5.85869Z",
  fill: "#282828"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.1437 11.9994V4.77759H17.7653V11.4588H24.0555V13.0804H17.2248C16.6277 13.0804 16.1437 12.5964 16.1437 11.9994Z",
  fill: "#282828"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.4146 14.9999L15.0057 19.4089C14.6891 19.7255 14.1758 19.7255 13.8591 19.409L11.3671 16.918L12.5135 15.7711L14.4322 17.689L18.268 13.8533L19.4146 14.9999Z",
  fill: "#282828"
});

function SvgActivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/Activate.de8a0f15.svg";
export { ForwardRef as ReactComponent };